import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { EmphasisLines } from '../EmphasisLines';
import { valueClosing, valueFeatures } from '../../data/salesContent';
export function ValueSection() {
  return <PageSection labelledBy="value-title" className="bg-slate-950" data-id="element-191" data-mp="27oyencvjrt7i">
      <SectionHeading id="value-title" title="Esto no es simplemente otro pack de ebooks sobre autos" subtitle={<p className="font-display text-lg font-extrabold uppercase text-cyan-400 md:text-xl" data-id="element-193" data-mp="2hgb27sabbx7q">Es un sistema visual listo para consultar.</p>} data-id="element-192" data-mp="2cij9wx5ra930" />
      <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-194" data-mp="2qhizq8508u0r">
        {valueFeatures.map(({
        icon: Icon,
        ...f
      }) => <li key={f.title} className="flex flex-col rounded-2xl border border-zinc-800 bg-zinc-900 p-6" data-id="element-195" data-mp="2vgvncv3pa54e">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-500/10 text-cyan-400" data-id="element-196" data-mp="w4az1zuclo77">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-197" data-mp="113dxv2jqiy6q" />
            </span>
            <h3 className="mt-4 font-display text-lg font-extrabold uppercase leading-tight text-white" data-id="element-198" data-mp="i7mzwgvspqfa">{f.title}</h3>
            {f.body && <p className="mt-2 text-base leading-relaxed text-zinc-300" data-id="element-199" data-mp="df3pttwbhdf8">{f.body}</p>}
            {f.stages && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-200" data-mp="8i3gna467ujw">
                {f.stages.map(s => <li key={s} className="rounded-md bg-cyan-500 px-2.5 py-1 font-display text-xs font-extrabold uppercase tracking-wide text-zinc-950" data-id="element-201" data-mp="4h02qt5oo8lb">
                    {s}
                  </li>)}
              </ul>}
            {f.list && <>
                <p className="mt-3 text-sm font-semibold text-zinc-200" data-id="element-202" data-mp="w51yab4118je">{f.listLead}</p>
                <ul className="mt-2 space-y-1" data-id="element-203" data-mp="s3q4rui1835x">
                  {f.list.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-relaxed text-zinc-300 md:text-base" data-id="element-204" data-mp="n5euxjrqlsnp">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500" aria-hidden="true" data-id="element-205" data-mp="3cx3b714me1ap" />
                      {item}
                    </li>)}
                </ul>
              </>}
          </li>)}
      </ul>
      <EmphasisLines lines={valueClosing} className="mt-10" data-id="element-206" data-mp="39c1ki8a51dzh" />
    </PageSection>;
}